// extracted by mini-css-extract-plugin
export var lightMode = "_c-0";